import { Box, Typography } from "@mui/material";
import WeekendIcon from "@mui/icons-material/Weekend";
import ChairIcon from "@mui/icons-material/Chair";
import BedIcon from "@mui/icons-material/Bed";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const dotTransition = {
  repeat: Infinity,
  ease: "easeInOut",
  duration: 0.6,
};

const iconMap = [
  <WeekendIcon style={{ fontSize: 34, color: "white" }} />,
  <ChairIcon style={{ fontSize: 34, color: "white" }} />,
  <BedIcon style={{ fontSize: 34, color: "white" }} />,
];

function LoadingMessage() {
  const { t } = useTranslation(["utilityPages"]);

  return (
    <Box
      component={motion.div}
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.4 }}
      className='w-60 h-60 rounded-full bg-cromboOrangeFade shadow-lg shadow-slate-300 flex flex-col items-center justify-center space-y-3'>
      {/* Bouncing Icons */}
      <Box className='flex space-x-3'>
        {iconMap.map((icon, i) => (
          <motion.div
            key={i}
            animate={{ y: ["0%", "-30%", "0%"] }}
            transition={{ ...dotTransition, delay: i * 0.2 }}>
            {icon}
          </motion.div>
        ))}
      </Box>

      {/* Enlarged Text */}
      <Typography
        variant='h6'
        className='text-white font-bold text-center leading-tight'>
        {t("utilityPages:loading")}
      </Typography>
    </Box>
  );
}

export default LoadingMessage;
